export default __webpack_public_path__ + "static/media/profile2.fbe6ce32.jpeg";